module.exports = __webpack_public_path__ + "media/pricing/ArtBooks-x2-aa40f593.png";